import cn from 'classnames';
import type { ReactNode } from 'react';

import { TooltipIconWrapper } from '@atoms/TooltipIconWrapper';

type Props = {
  label: string;
  children: ReactNode;
  className?: string;
  errorMessage?: string;
  tooltipText?: string;
};

export const LabelledInput = ({
  label,
  children,
  className,
  errorMessage,
  tooltipText = ''
}: Props) => {
  return (
    <div className={cn('flex flex-col', className)}>
      {tooltipText ? (
        <TooltipIconWrapper tooltipTitle={tooltipText}>
          <label className="mb-0.5 text-xs font-medium text-gray-500">
            {label}
          </label>
        </TooltipIconWrapper>
      ) : (
        <label className="mb-0.5 text-xs font-medium text-gray-500">
          {label}
        </label>
      )}
      {children}
      {errorMessage && <p className="text-feedback-error">{errorMessage}</p>}
    </div>
  );
};
